import { Status, StatusCreateRequest, StatusUpdateRequest, StatusReorderRequest, StatusDeleteValidation, StatusDeleteResult } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};

export const statusApi = {
  // Get all statuses for an organization
  async getStatuses(): Promise<Status[]> {
    const response = await fetch(`${API_BASE_URL}/status/GetAll`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch statuses');
    }

    return response.json();
  },

  // Create a new status
  async createStatus(status: StatusCreateRequest): Promise<Status> {
    const response = await fetch(`${API_BASE_URL}/status/Create`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(status),
    });

    if (!response.ok) {
      throw new Error('Failed to create status');
    }

    return response.json();
  },

  // Update a status
  async updateStatus(id: string, status: StatusUpdateRequest): Promise<Status> {
    const response = await fetch(`${API_BASE_URL}/status/Update/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(status),
    });

    if (!response.ok) {
      throw new Error('Failed to update status');
    }

    return response.json();
  },

  // Check if a status can be deleted
  async canDeleteStatus(id: string): Promise<StatusDeleteValidation> {
    const response = await fetch(`${API_BASE_URL}/status/CanDeleteStatus/${id}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to check status deletion');
    }

    return response.json();
  },

  // Delete a status
  async deleteStatus(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/status/Delete/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to delete status');
    }
  },

  // Delete a status with transfer
  async deleteStatusWithTransfer(id: string, transferToStatusId: string): Promise<StatusDeleteResult> {
    const response = await fetch(`${API_BASE_URL}/status/DeleteWithTransfer/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      body: JSON.stringify({ transferToStatusId }),
    });

    if (!response.ok) {
      throw new Error('Failed to delete status with transfer');
    }

    return response.json();
  },

  // Reorder statuses
  async reorderStatuses(reorderRequest: StatusReorderRequest): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/status/ReorderStatuses`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(reorderRequest),
    });

    if (!response.ok) {
      throw new Error('Failed to reorder statuses');
    }
  },

  // Initialize default statuses for an organization
  async initializeDefaultStatuses(organizationId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/status/InitializeDefaultStatuses`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to initialize default statuses');
    }
  },
};
